import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import {Stack} from "@mui/material";

import {useDispatch} from "react-redux";

import {changeWorkIssuance} from "../workIssuanceSlice";



export default function WorkIssuanceCashAccrualCashUltimatesTabs(props) {
    const [workIssuanceTabValue, setWorkIssuanceTabValue] = React.useState(0);

    const dispatchData = useDispatch();


    const handleChange = (event, newValue) => {
        setWorkIssuanceTabValue(newValue);
        if(newValue == 0){
            dispatchData(changeWorkIssuance({cashState: true, accrualState: false, liabilityState: false, ultimatesState: false,
                clearData: true}));

            console.log("cash tab selected");
        }
        if(newValue == 1){
            dispatchData(changeWorkIssuance({cashState: false, accrualState: true, liabilityState: false, ultimatesState: false,
                clearData: true}));
            console.log("accrual tab selected");
        }
        if(newValue == 2){
            dispatchData(changeWorkIssuance({cashState: false, accrualState: false, liabilityState: true, ultimatesState: false,
                clearData: true}));
            console.log("liability tab selected");
        }
        if(newValue ==3){
            dispatchData(changeWorkIssuance({cashState: false, accrualState: false, liabilityState: false, ultimatesState: true,
                clearData: true}));
            console.log("ultimates tab selected");
        }
    };

    return (
        <Stack direction="row" spacing={0}>

            <Box sx={{pt: 2,  width: 400, height: 40, bgcolor: 'background.paper' }}>
                <Tabs value={workIssuanceTabValue} defaultValue={0}
                      onChange={handleChange} >
                    <Tab label="Cash"         />
                    <Tab label="Accrual"         />
                    <Tab label="Liability"         />
                    <Tab  label="Ultimates"/>
                </Tabs>
            </Box>
        </Stack>
    );
}
